import React from 'react';
import Link from 'next/link';
import { CallTo } from 'components/common';

const SellYourMachineIn30Days = () => {
  return (
    <div className="row mb-20">
      <div className="col">
        <div
          className="media-container media-container--height-165"
          style={{ backgroundImage: 'url(/temp/machinery_group.jpeg)' }}
        >
          <div className="media-container--text">
            <div className="text-white fs-14 fw-900 mb-30">İŞ MAKİNANIZI 30 GÜNDE SATALIM</div>
            <div className="text-white fs-14 mb-30 mb-4">
              <span>
                Bize Ulaşın
                {' '}
                <CallTo className="text-white" tel="+90 (850) 885 46 25" />
              </span>
            </div>
            <Link href="/machine-sales">
              <a className="im-button im-button--primary">
                <span>Hemen Aramaya Başla</span>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellYourMachineIn30Days;
